import { useContext } from 'react';

import { Accessories, AdditionalData, GeneralData } from '..';
import { Card } from '@hdi-seguros/web-components.card';

import { WizardDataFormContext } from '../../../../../../Wizard/contexts/WizardDataForm';

interface TabsPropertyDataCarProps {
  duplicateId?: number;
  id: number;
}

export const TabsPropertyDataCar = ({
  duplicateId,
  id,
}: TabsPropertyDataCarProps) => {
  const { articleHasScoring } = useContext(WizardDataFormContext);
  
  return (
    <Card>
      <GeneralData duplicateId={duplicateId} id={id} />

      <Accessories duplicateId={duplicateId} id={id} />

      {articleHasScoring ? (
        <AdditionalData duplicateId={duplicateId} id={id} />
      ) : (
        <></>
      )}
    </Card>
  );
};
